import SchedulesList from "../../../pages/planner/schedule/List";
import SchedulesEdit from "../../../pages/planner/schedule/Edit";
import EventsList from "../../../pages/planner/event/List";
import EventsEdit from "../../../pages/planner/event/Edit";
import {
    getSiteEventChatOverlayRoute,
    getSiteEventEditRoute,
    getSiteEventLiveRoute,
    getSiteEventsRoute,
    getSiteScheduleEditRoute,
    getSiteSchedulesRoute
}                 from './factory/planner';
import Live       from "../../../pages/planner/event/Live";
import Chat       from '../../../pages/planner/event/overlay/Chat';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
    {
        path: getSiteSchedulesRoute(),
        component: SchedulesList,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getSiteScheduleEditRoute(),
        component: SchedulesEdit,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getSiteEventsRoute(),
        component: EventsList,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getSiteEventLiveRoute(),
        component: Live,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
    {
        path: getSiteEventChatOverlayRoute(),
        component: Chat,
        exact: false,
        type: 'route',
        loginRequired: false,
    },
    {
        path: getSiteEventEditRoute(),
        component: EventsEdit,
        exact: false,
        type: 'route',
        loginRequired: true,
    },
];

export default routes;